'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = Icon;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./icon.scss');

require('./sportsbook.icons.json');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Icon Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>} HTML markup for the component
 */

// css
function Icon(props) {
    var _cx;

    var _props$name = props.name,
        name = _props$name === undefined ? '' : _props$name,
        _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id,
        _props$imageSrc = props.imageSrc,
        imageSrc = _props$imageSrc === undefined ? '' : _props$imageSrc,
        _props$colour = props.colour,
        colour = _props$colour === undefined ? '' : _props$colour,
        _props$isSolid = props.isSolid,
        isSolid = _props$isSolid === undefined ? false : _props$isSolid,
        _props$isDark = props.isDark,
        isDark = _props$isDark === undefined ? false : _props$isDark;


    var classNames = (0, _classnames2.default)((_cx = {
        'sb-icon-image': !!imageSrc,
        'sb-icon sb-icon--solid': isSolid,
        'sb-icon--dark': isDark
    }, (0, _defineProperty3.default)(_cx, 'sb-icon sb-icon-' + name, !imageSrc), (0, _defineProperty3.default)(_cx, '' + className, className), _cx));

    var iconImageStyles = {
        backgroundImage: 'url(' + imageSrc + ')'
    };

    var iconStyles = {
        backgroundColor: colour
    };

    if (imageSrc) {
        return (0, _jsx3.default)('span', {
            style: iconImageStyles,
            className: classNames,
            id: id
        });
    }

    return (0, _jsx3.default)('span', {
        style: iconStyles,
        className: classNames,
        id: id
    });
}
// icons
//# sourceMappingURL=Icon.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/icons/dist/main/Icon.js
// module id = 466
// module chunks = 0